export default __webpack_public_path__ + "static/media/ve.42c44704.svg";